

// export async function fetchGoalsFromSheet() {
//   try {
//     const res = await fetch("https://eofjypa6hm8hgwf.m.pipedream.net");
//     if (!res.ok) throw new Error(`HTTP ${res.status}`);

//     const json = await res.json();
//     console.log("✅ Raw sheet data:", json);

//     const rows = Array.isArray(json.$return_value) ? json.$return_value : [];

//     const mappedGoals = {};

//     if (rows.length > 1) {
//       rows.slice(1).forEach(([fullName, goal]) => {
//         if (fullName && goal) {
//           mappedGoals[fullName.trim()] = Number(goal);
//         }
//       });
//     }

//     console.log("✅ Parsed goals:", mappedGoals);
//     return mappedGoals;
//   } catch (error) {
//     console.error("❌ Failed to fetch goals from sheet:", error);
//     return {};
//   }
// }

export async function fetchGoalsFromSheet(selectedDate = null) {
  try {
    const res = await fetch("https://eofjypa6hm8hgwf.m.pipedream.net");
    if (!res.ok) throw new Error(`HTTP ${res.status}`);

    const json = await res.json();
    const rows = Array.isArray(json.$return_value) ? json.$return_value : [];

    let mappedGoals = {};
    
    // Parse the selected date with explicit timezone handling
    const selectedDate_obj = selectedDate 
      ? new Date(selectedDate + 'T00:00:00Z') 
      : new Date();
    
    // Explicitly calculate month and year
    const selectedMonth = selectedDate_obj.getUTCMonth() + 1; // Add 1 to match sheet's month numbering
    const selectedYear = selectedDate_obj.getUTCFullYear();

    console.log(`🔍 DETAILED DEBUG: 
      Raw Selected Date: ${selectedDate}
      Selected Date Object: ${selectedDate_obj}
      Selected Month (1-indexed): ${selectedMonth}
      Selected Year: ${selectedYear}
    `);

    if (rows.length > 1) {
      rows.slice(1).forEach(([fullName, goal, timestamp], index) => {
        if (fullName) {
          const trimmedName = fullName.trim();
          
          // Careful timestamp parsing with UTC methods
          const timestampDate = new Date(timestamp);
          const timestampMonth = timestampDate.getUTCMonth() + 1;
          const timestampYear = timestampDate.getUTCFullYear();
          
          console.log(`🔬 TIMESTAMP ANALYSIS:
            Name: ${trimmedName}
            Raw Timestamp: ${timestamp}
            Parsed Timestamp Date: ${timestampDate}
            Timestamp Month (1-indexed): ${timestampMonth}
            Timestamp Year: ${timestampYear}
            Selected Month: ${selectedMonth}
            Selected Year: ${selectedYear}
            Month Match: ${timestampMonth === selectedMonth}
            Year Match: ${timestampYear === selectedYear}
          `);

          // Explicitly match selected month and year
          if (timestampMonth === selectedMonth && timestampYear === selectedYear) {
            mappedGoals[trimmedName] = Number(goal) || 0;
            console.log(`✅ GOAL ADDED for ${trimmedName}: ${Number(goal) || 0}`);
          } else {
            console.log(`❌ GOAL SKIPPED for ${trimmedName}`);
          }
        }
      });
    }

    console.log("🏁 FINAL Parsed Goals:", mappedGoals);
    return mappedGoals;
  } catch (error) {
    console.error("❌ Failed to fetch goals from sheet:", error);
    return {};
  }
}




